import { useContext } from "react"
import { CommandCenterStateProviderContext } from "../context"

const useSocket = () => {
    const context = useContext(CommandCenterStateProviderContext)
    if (!context) {
        throw new Error('useSocket must be used within a SocketProvider')
    }
    const { socket, setSocket } = context
    return { socket, setSocket }
}
export default useSocket